import React from 'react'
import {
  Button,
  Label,
  ListBox,
  ListBoxItem,
  Popover,
  Select,
  SelectValue,
} from 'react-aria-components'

export interface SelectOption<T extends string> {
  value: T
  label: string
}

interface SelectFieldProps<T extends string> {
  label: string
  value: T
  options: SelectOption<T>[]
  onChange: (value: T) => void
}

export function SelectField<T extends string>({
  label,
  value,
  options,
  onChange,
}: SelectFieldProps<T>) {
  return (
    <Select
      selectedKey={value}
      onSelectionChange={(key) => onChange(key as T)}
      className="space-y-1.5"
    >
      <Label className="text-xs font-medium text-gray-600">{label}</Label>
      <Button className="w-full px-3 py-2 text-sm border border-gray-200 rounded-md bg-white focus:outline-none focus:ring-2 focus:ring-gray-900 focus:border-transparent flex items-center justify-between cursor-pointer">
        <SelectValue />
        <span className="text-xs text-gray-400">▾</span>
      </Button>
      <Popover className="z-50 w-[--trigger-width] rounded-lg border border-gray-200 bg-white shadow-xl">
        <ListBox className="max-h-60 overflow-auto p-1 text-sm">
          {options.map((option) => (
            <ListBoxItem
              key={option.value}
              id={option.value}
              className={({ isFocused, isSelected }) =>
                `cursor-pointer rounded-md px-3 py-2 outline-none ${
                  isSelected
                    ? 'bg-gray-900 text-white'
                    : isFocused
                      ? 'bg-gray-100 text-gray-900'
                      : 'text-gray-700'
                }`
              }
            >
              {option.label}
            </ListBoxItem>
          ))}
        </ListBox>
      </Popover>
    </Select>
  )
}
